module.exports = __webpack_public_path__ + "images/柏纳长图_10-2.jpg?v=f3023e8b";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_10-2.jpg
 ** module id = 152
 ** module chunks = 1 2
 **/